import { Section, Container, H2, useMedia, P, H3, multiMedia } from 'fractals'
import { slugify } from 'ui'
import { Box } from '@mui/material'
import { TFullProgramContentsProps } from './fractals'
import { ContentPart, FullContentChip } from './fractals/components'

const FullProgramContents = ({
  heading,
  fullProgramContents
}: TFullProgramContentsProps) => {
  const { isTablet, isMobile, isDesktop } = useMedia()
  const isSmallScreen = isTablet || isMobile

  if (!fullProgramContents) return null

  const {
    color,
    description,
    durationInMonths,
    contentHours,
    workshopsHours,
    supervisionHours,
    bulletsTitle,
    bullets,
    parts,
    durationInMonthsTitle,
    contentHoursTitle,
    workshopsHoursTitle,
    supervisionHoursTitle
  } = fullProgramContents

  const stats = [
    {
      title: durationInMonthsTitle || 'Месяцев обучения',
      value: durationInMonths
    },
    {
      title: contentHoursTitle || 'Часов обучения',
      value: contentHours
    },
    {
      title: workshopsHoursTitle || 'Часов практикумов',
      value: workshopsHours
    },
    {
      title: supervisionHoursTitle || 'Часов супервизий',
      value: supervisionHours
    }
  ]

  return (
    <>
      <section
        id={slugify(heading)}
        style={{
          background: isSmallScreen
            ? color ?? ''
            : `linear-gradient(to right, ${color} 65%, #fff 65%)`,
          paddingTop: isSmallScreen ? '3.5rem' : 'unset',
          paddingBottom: isSmallScreen ? '3.5rem' : 'unset'
        }}>
        <Container
          styles={{
            display: 'flex',
            justifyContent: isSmallScreen ? 'initial' : 'space-between',
            color: '#fff',
            gap: '68px',
            flexDirection: isSmallScreen ? 'column' : 'row'
          }}>
          <Box
            paddingY={isSmallScreen ? 'unset' : '5rem'}
            sx={{
              maxWidth: '700px'
            }}>
            <H2 variant='fullContentTitle'>{heading}</H2>
            <P
              variant='zeta'
              styles={{
                marginBottom: '48px',
                ...multiMedia({
                  phone: {
                    marginBottom: '24px'
                  }
                })
              }}>
              {description}
            </P>
            <Box
              display='flex'
              justifyContent={isMobile ? 'initial' : 'space-between'}
              flexWrap={isSmallScreen ? 'wrap' : 'unset'}
              padding='24px'
              borderRadius='16px'
              color='#000'
              gap={isSmallScreen ? '20px' : 'unset'}
              width={isSmallScreen ? 'unset' : '100%'}
              sx={{
                backgroundColor: '#fff'
              }}>
              {stats.map(({ title, value }) => (
                <Box
                  key={title}
                  sx={{
                    '&+&': {
                      paddingLeft: isSmallScreen ? 'unset' : '24px',
                      borderLeft: isSmallScreen ? 'unset' : '1px solid black',
                      marginLeft: isSmallScreen ? 'unset' : '5px'
                    }
                  }}>
                  <Box
                    fontSize={isSmallScreen ? '40px' : '48px'}
                    lineHeight='100%'
                    fontWeight={400}
                    mb='7px'>
                    {value}
                  </Box>
                  <Box fontSize='14px' lineHeight='120%' fontWeight={500}>
                    {title}
                  </Box>
                </Box>
              ))}
            </Box>
          </Box>
          <Box
            // eslint-disable-next-line no-nested-ternary
            width={isSmallScreen ? '100%' : isDesktop ? '35%' : '43%'}
            borderRadius='16px'
            boxSizing='border-box'
            padding={isSmallScreen ? '24px' : '80px 0px 80px 80px'}
            color='#000'
            sx={{
              backgroundColor: '#fff'
            }}>
            <H3 variant='fullProgramsContent'>{bulletsTitle}</H3>
            <Box display='flex' flexWrap='wrap' gap='8px'>
              {bullets.map(({ text, id }) => (
                <FullContentChip key={id} label={text} color={color} />
              ))}
            </Box>
          </Box>
        </Container>
      </section>
      <Section
        id={slugify(`${heading}-2`)}
        spacingVariant='beta'
        colorsVariant='beta'
        colorVariant={{ color: '#F2F2F2' }}
        styles={{
          paddingTop: isSmallScreen ? '3.5rem' : '4rem',
          paddingBottom: isSmallScreen ? '3.5rem' : '4rem'
        }}>
        <Container>
          {parts.map(part => (
            <ContentPart part={part} color={color} key={part.id} />
          ))}
        </Container>
      </Section>
    </>
  )
}

export default FullProgramContents
